import React from "react"
import JSONPretty from "react-json-pretty"
import { getCachedOutputAsObject } from "services/cachedRandom/random.service"
import { useEFSData } from "hooks/efs-input"

const ShowRandomCacheOutput = () => {
  const { showOutput } = useEFSData()

  const cacheOutput = getCachedOutputAsObject()

  if (!showOutput) {
    return null
  }

  return (
    <div>
      <h4>Cached Random:</h4>
      <JSONPretty data={cacheOutput} />
    </div>
  )
}

export default ShowRandomCacheOutput
